// axios.js
import axios from 'axios';
import router from '../router';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // API基础URL
  timeout: 2000000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从本地存储获取token并添加到请求头
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `${token}`;
    }
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 跳转到登录页的函数，避免重复导航
const redirectToLogin = () => {
  // 清除用户信息
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
  
  // 只有当前不在登录页时才进行跳转
  if (router.currentRoute.path !== '/login') {
    router.replace('/login').catch(err => {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
  }
};

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    
    // 根据状态码处理响应
    if (res.code !== 200 && res.code !== 0) {
      // 处理未授权（401）和禁止访问（403）
      if (res.code === 401) {
        redirectToLogin();
      }
      return Promise.reject(new Error(res.message || res.msg || '未知错误'));
    } else {
      return res;
    }
  },
  error => {
    console.error('响应错误:', error?.response?.data?.message);
    // 处理网络错误或服务器错误
    let errorMessage = '连接服务器失败';
    if (error.response) {
      // 服务器返回错误状态码
      switch (error.response.status) {
        case 401:
          errorMessage = '请重新登录';
          redirectToLogin();
          break;
        case 403:
          errorMessage = '拒绝访问';
          break;
        case 404:
          errorMessage = '请求的资源不存在';
          break;
        case 500:
          errorMessage = '服务器内部错误';
          break;
        default:
          errorMessage = `请求错误: ${error.response.status}`;
      }
    } else if (error.request) {
      // 请求发送但没有收到响应
      errorMessage = '服务器无响应';
    }
    
    return Promise.reject(error?.response?.data || {message: errorMessage});
  }
);

// 导出请求方法
export const get = (url, params, options) => service.get(url, { params, ...options });
export const post = (url, data, options) => service.post(url, data, options);
export const put = (url, data, options) => service.put(url, data, options);
export const del = (url, options) => service.delete(url, options);

export default service;